module.exports = __webpack_public_path__ + "img/braintree-logo-dark.e0f1fbae.png";